import {
  STRIPE_OBJECT_TYPE_CARD,
  STRIPE_OBJECT_TYPE_BANK_ACCOUNT,
} from 'common/stripeConstants';

import {
  PLAID_STATUS_PENDING_AUTOMATIC_VERIFICATION,
  PLAID_STATUS_PENDING_MANUAL_VERIFICATION,
} from 'common/plaidConstants';

export const PAYMENT_ACCOUNT_CARD = 'CreditDebitCard';
export const PAYMENT_ACCOUNT_BANK_ACCOUNT = 'BankAccount';

export const PAYMENT_ACCOUNT_STATUS_ACTIVE = 'active';
export const PAYMENT_ACCOUNT_STATUS_DELETED = 'deleted';
// this means the payment account will be automatically verified without the user having to do anything
export const PAYMENT_ACCOUNT_STATUS_PENDING_AUTOMATIC_VERIFICATION = 'pendingAutomaticVerification';
// this means the user would have to verify the payment account themselves through micro-deposits
export const PAYMENT_ACCOUNT_STATUS_PENDING_MANUAL_VERIFICATION = 'pendingManualVerification';

export const stripeToPaymentAccountMapping = {
  [STRIPE_OBJECT_TYPE_CARD]: PAYMENT_ACCOUNT_CARD,
  [STRIPE_OBJECT_TYPE_BANK_ACCOUNT]: PAYMENT_ACCOUNT_BANK_ACCOUNT,
};

export const plaidToPaymentAccountStatusMapping = {
  [PLAID_STATUS_PENDING_AUTOMATIC_VERIFICATION]: PAYMENT_ACCOUNT_STATUS_PENDING_AUTOMATIC_VERIFICATION,
  [PLAID_STATUS_PENDING_MANUAL_VERIFICATION]: PAYMENT_ACCOUNT_STATUS_PENDING_MANUAL_VERIFICATION,
};
